import React, { Fragment } from 'react'
import { Timeline, Typography } from 'antd'
import { includes, map } from 'lodash'

import { EVENT_TYPES } from '../../common/constants'
import { eventDifference, getEventDifferenceText } from '../../common/helpers'
import { formatCreatedByText } from '../../common/utils'

const renderUserEvent = event => {
  const { type, original, changes, createdAt, createdBy } = event

  if (type !== EVENT_TYPES.UPDATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          {type === EVENT_TYPES.CREATE ? 'Created' : 'Deleted'} {changes.type}{' '}
          {type === EVENT_TYPES.CREATE ? changes.name : original.name}
        </Typography.Text>
        <br />
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  const eventDifferences = eventDifference(original, changes, 'name')

  const mappedEventDifferences = map(
    eventDifferences,
    ({ differentKey, original, change }) => {
      if (includes(['roles', 'cuisineTypes', 'languages'], differentKey)) {
        return {
          differentKey,
          original: map(original, 'name'),
          change: map(change, 'name'),
        }
      }

      return { differentKey, original, change }
    },
  )

  return (
    <Timeline.Item key={event.id}>
      <Typography.Text>Updated {original.name}:</Typography.Text>
      <br />
      {map(mappedEventDifferences, ({ differentKey, original, change }) => (
        <Fragment key={differentKey}>
          <Typography.Text>
            {getEventDifferenceText(differentKey, original, change)}
          </Typography.Text>
          <br />
        </Fragment>
      ))}
      <Typography.Text>
        {formatCreatedByText(createdAt, createdBy.name)}
      </Typography.Text>
    </Timeline.Item>
  )
}

export default renderUserEvent
